export const API_ROUTES = {
  SUBMIT_OTP_ROUTE: "/user/request-otp/",
  SUBMIT_LOGIN_ROUTE: "/user/login/",
  FETCH_AUCTION_PRODUCTS: "/auction/products?auction_id=",
  FETCH_ALL_AUCTION: "/auction/list-all",
  SUBMIT_BID_AUCTION: "/auction/bids/create",
  FETCH_FEATURE_SETTINGS: "/media/feature_settings/?key=",
  SUBMIT_IMAGE: '/auction/appsmith/upload_images',
  SUBMIT_NBFC_LOGIN_ROUTE: '/auction/api/token/',
  CREATE_AUCTION_ROUTE: '/auction/create',
  FETCH_UPLOADED_AUCTION_ROUTE: '/auction/appsmith/auctions?user_group=',
  FETCH_UPLOADED_AUCTION_SINGLE_INVENTORY_ROUTE: '/auction/appsmith/products?auction_id=',
  FETCH_BID_STATUS_ROUTE: '/auction/appsmith/productbids?product_id=',
  SUBMIT_UPDATE_BID_STATUS_ROUTE: '/auction/bids/',
};

export const API_BASE_URL = {
     BASE_URL: process.env.REACT_APP_BASE_URL
       ? process.env.REACT_APP_BASE_URL
               : "https://used-tractor-backend-staging.azurewebsites.net",
};

export const BLOB_BASE_URL = {
  BASE_URL: process.env.REACT_APP_AZURE_BLOB_BASE_URL
    ? process.env.REACT_APP_AZURE_BLOB_BASE_URL
            : "https://castagingstorage.blob.core.windows.net/used-tractor-media-staging",
};

export const BLOB_SASTOKEN = {
BASE_URL: process.env.REACT_APP_AZURE_SAS_TOKEN
  ? process.env.REACT_APP_AZURE_SAS_TOKEN
          : "?sv=2021-06-08&ss=b&srt=sco&sp=rwlaciyx&se=2026-02-17T12:32:27Z&st=2023-02-17T04:32:27Z&spr=https&sig=6GEiTugwrJSoEXqNKJx2fdla07T%2FyFOLm9ku8fzc6fA%3D",
};

  